import { Injectable } from "@angular/core";
import { distinctUntilChanged } from "rxjs/operators";
import { BehaviorSubject, Observable } from "rxjs";
import { UserHttpService } from "./user-http.service";
import { User } from "../../core/data/user/user.model";
import { AuthenticationService } from "../../core/authentication/authentication.service";
import { ErrorService } from "../../core/error/error.service";

@Injectable()
export class UserService {
  public usersList$: Observable<any>;
  public currentUser$: Observable<any>;
  private usersListSubject: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private currentUserSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private userHttp: UserHttpService,
    private authService: AuthenticationService,
    private errorService: ErrorService
  ) {
    /**
     * We check the user status in the authentication service.
     * if the userStatus differ from unlogged it means that we
     * have login information in the storage so we can get
     * the current user. If the request succeed we can update
     * the currentuser subject and we can check teh real status
     * of the user and update in case it differs the one in the
     * authentication service.
     */
    this.usersList$ = this.usersListSubject
      .asObservable()
      .pipe(
        distinctUntilChanged()
      );

    this.currentUser$ = this.currentUserSubject
      .asObservable()
      .pipe(
        distinctUntilChanged()
      );

    this.authService.currentUser$.subscribe(user => {
      this.currentUserSubject.next(user);
    })

  }

  updateUser(userFileds: any = {}) {
    const prevUser = this.currentUserSubject.getValue();
    const obs$ = this.userHttp.update(prevUser._id, userFileds);
    obs$.catch(e => {
      this.errorService.addError(e);
      return Observable.of(null);
    }).subscribe(user => {
      if (user) {
        this.currentUserSubject.next(user);
      }
    });
    return obs$;
  }

  updateUserWithUid(userFileds: any, uid: string){
    if(userFileds && uid){
      const obs$ = this.userHttp.update(uid, userFileds);
      obs$.catch(e => {
        this.errorService.addError(e);
        return Observable.of(null);
      }).subscribe(user => {
        if (user) {
          this.errorService.addError('SUCCESS_PWD');
          this.currentUserSubject.next(user);
        }
      });
      return obs$;
    }
  }

  getUser(id: string): Observable<User> {
    this.userHttp.get(id)
    .map(user => {
      this.currentUserSubject.next(user);
      return user;
    });
    return this.currentUser$;
  }

  updatePassword(id: string, token: string, password: string) {
    if (id && token && password) {
      this.userHttp.updatePassword(id, token, password)
      .catch(e => {
        this.errorService.addError(e.error);
        return Observable.of(null);
      })
      .subscribe(user => {
        if (user) {
          this.errorService.addError('SUCCESS_PWD');
          this.currentUserSubject.next(user);
        }
      });
    }
  }

  removeCurrentUser(){
    return this.currentUserSubject.next(null);
  }
  getCurrentUser() {
    return this.currentUserSubject.getValue();
  }

}


// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts